import { render, staticRenderFns } from "./BoughtPerDay.vue?vue&type=template&id=5ee165f1&"
import script from "./BoughtPerDay.vue?vue&type=script&lang=js&"
export * from "./BoughtPerDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports